/** @module Specification/BOM/SizeMappingMatrix */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/table/matrix/Path",
	"csi/xml",
	"Specification/SizeVariationParams",
], function(declare, _, PathMatrix, xml, SizeVariationParams) {

	return declare(PathMatrix, {
		hideLoneSubheader: true,

		/**
		 * @override
		 * Allow drag-fill across columns
		 */
		onPathSubSpecParams: function(ctx, params, columnIndex) {
			if (columnIndex !== undefined) {
				params.allowCopyToMatrixColumns = true;
			}
		},

		/**
		 * @override
		 * Create the PartMaterialSize node for row and column
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			var view = ctx.view;
			var rootNode = view.getViewNode();
			var variationObj = view.bomSizeVariation;
			var targetSizeKey = null;
			var targetSize = null;

			if (view.bomSizeSet.has2dSizes()) {
				targetSize = targetSizeKey = view.bomSizeSet.get2dSizeUrl(c.columnUrl, node.$URL);
			} else {
				targetSize = node.$URL;
				targetSizeKey = node.$URL + "^" + c.sid;
				const id = c.heading.m_subheadings[0].m_id;
				variationObj = [SizeVariationParams.SIZE_PARAMS, SizeVariationParams.QTY_PARAMS, SizeVariationParams.SIZE_SPEC_PARAMS].find((params) => params.attr === id);
			}

			// if the actual size is not applicable, then skip it
			if (!targetSizeKey) {
				return null;
			}

			// if OnlyForSizes is not null, don't display the cells which not in that list
			if (!_.isEmpty(rootNode.OnlyForSizes) && !_.contains(rootNode.OnlyForSizes, targetSize)) {
				return null;
			}

			var clientNode = view.variationNodeMap[targetSizeKey];
			if (!clientNode) {
				var variationNodes = ctx.cache.getNodes(rootNode[variationObj.composition]);
				const variationNode = _.find(variationNodes, (variationNode) => _.contains(variationNode[variationObj.aggregation], targetSize));

				// not exists yet, create it
				clientNode = ctx.cache.createClientNode(null, variationObj.nodeType, node.$Name);
				xml.nodeCreateClientAttr(clientNode, xml.ATTR_PARENT, xml.ATTR_REF, rootNode.$URL);
				xml.nodeCreateClientAttr(clientNode, view.ATTR_VALUE, xml.ATTR_REF, targetSize);

				// set the attribute for the client node, notice that we prefer the value from cache, if not, then get the value from DB
				xml.nodeCreateClientAttr(
					clientNode,
					variationObj.attr,
					variationObj.attrType,
					variationNode ? variationNode[variationObj.attr] : (rootNode[variationObj.common] || xml.attributeTypeGetDefaultValue(variationObj.attrType))
				);

				// cache it
				view.variationNodeMap[targetSizeKey] = clientNode;
			}

			return [clientNode];
		},

		/**
		 * @override
		 * Use subheading names for column names
		 */
		_getColumnSpecHeaderParams: function(ctx, h, index) {
			let hparams = this.inherited(arguments);
			if (!ctx.view.bomSizeSet.has2dSizes()) {
				hparams.innerText = h.m_subheadings[0].m_name;
			}
			return hparams;
		},

		/**
		 * @override
		 * Get the column nodes
		 */
		_getColumnNodes: function(ctx, h) {
			return ctx.view.bomSizeColumns;
		}
	});
});